// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Mauritania */
const MR = /^(?:[2-4][0-46-9]\d{6})$/;

export default MR;
